import React, { useState } from 'react';
import Modal from './modal';
import toast from 'react-hot-toast';

const UpdateModal = ({ isOpen, onClose, onSave, title, placeholder }) => {
  const [note, setNote] = useState('');


  const handleSubmit = () => {
    if (note.trim().length < 1) {
      toast.error('This field should not be empty');
      return;
    }
    onSave(note);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="text-lg font-semibold mb-4">{title}</h2>
      {title === 'Add new Note' ? (
        <textarea
          className="w-full p-2 border rounded resize-none h-32 focus:outline-none"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder={placeholder}
        />) : (
        <input
          className="w-full  p-2 border rounded resize-none focus:outline-none"
          value={note}
          required
          onChange={(e) => setNote(e.target.value)}
          placeholder={placeholder}
        />
      )}
      <div className="mt-4 flex justify-end space-x-2">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        >
          Save
        </button>
      </div>
    </Modal>
  );
};

export default UpdateModal;
